// removed by extract-text-webpack-plugin
module.exports = {"container":"Iti6P8Y2Dh9dRBCoZNJjT","routes":"_1G3tvTNoNa-dePPB44ba2t"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/DocumentInformation/styles.css
// module id = 3269
// module chunks = 0